import { useMemo } from 'react';

import { Translate } from '@dreryk/react-common';
import { Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../translations';
import { useTotalPrice } from '../totalPrice/totalPrice.utils';

import { VisitMedicalServiceTableBean } from './medicalServices.types';

type TotalPriceTextProps = {
   readonly totalPrice: string | null;
};

export const TotalPriceText = (props: TotalPriceTextProps): JSX.Element => {
   return (
      <TextSeparator separator={TextSeparatorType.COLON_SPACE}>
         <Text as={'strong'} testId={'label'}>
            <Translate>{visitSettlementTranslationKeys.shared.medicalServices.totalPrice.label}</Translate>
         </Text>
         <Text testId={'price'} whiteSpaces={'nowrap'}>
            {props.totalPrice}
         </Text>
      </TextSeparator>
   );
};

type MedicalServicesTotalPriceTextProps = {
   readonly medicalServices: VisitMedicalServiceTableBean[];
};

export const MedicalServicesTotalPriceText = (props: MedicalServicesTotalPriceTextProps): JSX.Element => {
   const prices = useMemo(() => (props.medicalServices ?? []).map((bean) => bean?.price ?? 0), [props.medicalServices]);
   const totalPrice = useTotalPrice(prices);

   return <TotalPriceText totalPrice={totalPrice} />;
};
